// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"c0140f78","453":"b810c280","455":"1b5c9848","977":"7225137e"}[chunkId] + ".chunk.js";
};